var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTraining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 101,
    viewBox: "0 0 90 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_549_58",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9634 0.00390625H0.00683594V100.411H89.9634V0.00390625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_549_58)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8911 71.8852V80.7674C77.8911 89.0204 63.508 100.077 44.986 100.077C26.4639 100.077 11.4268 86.7165 11.4268 78.4635V56.4451C11.4268 55.8582 11.7665 55.3229 12.3058 55.0584C12.8451 54.7939 13.492 54.8487 13.9768 55.1977L40.0078 73.9261C42.4237 75.6603 47.1624 75.6697 49.6098 73.9261L74.3059 57.9069L74.324 71.0103C74.324 72.0276 76.6746 72.5817 77.625 72.0386C77.706 71.9932 77.7943 71.9415 77.8911 71.8852Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.357 42.0919L49.6109 63.3403C47.1626 65.0899 42.4248 65.0822 40.0093 63.3403L1.82899 35.8409C-0.594077 34.097 -0.606551 30.6825 1.84419 28.9232L40.3388 1.32363C42.7971 -0.439515 47.5628 -0.429881 49.9884 1.32363L88.1686 28.9232C90.5514 30.6478 90.5967 34.0604 88.1057 35.8409L85.2926 37.8488L85.2599 61.0279C85.2599 62.001 82.8444 63.7854 81.9134 64.4463C81.1837 64.9666 79.3797 64.4367 79.3797 63.4636L79.357 42.0919Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraining);
export default __webpack_public_path__ + "static/media/icon_training.cb57f65c929d6ce066cfc05c9f9d57a0.svg";
export { ForwardRef as ReactComponent };